import { Autocomplete, TextField, Tooltip, Box, Typography } from "@mui/material";
import { useField } from "formik";
import React, { useState, useRef } from "react";


const IndustryAutocomplete = ({ name, label, industryTypes, disabled = false }) => {
  const [field, meta, helpers] = useField(name);
  const { setValue } = helpers;
  const selected = industryTypes.find(i => i.industryType === field.value) || null;
  const [inputTouched, setInputTouched] = useState(false);
  const inputRef = useRef(null);

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        {label} <span className="text-red-500">*</span>
      </label>

      <Autocomplete
        options={industryTypes}
        getOptionLabel={(option) => option.industryType}
        value={selected}
        onChange={(e, val) => setValue(val?.industryType || '')}
        filterOptions={(options, state) => {
          const input = state.inputValue.trim().toLowerCase();
          if (input === '') return options;
          if (input.length < 3) return [];
          return options.filter(o =>
            o.industryType.toLowerCase().includes(input)
          );
        }}
        openOnFocus={false}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            placeholder="Select Industry"
            size="small"
            error={meta.touched && !!meta.error}
            helperText={meta.touched && meta.error}
            fullWidth
            sx={{
              '& input::placeholder': {
                color: '#000',
                opacity: 1,
              },
              ...(disabled && {
                '& .MuiOutlinedInput-root': {
                  border: 'none',
                  backgroundColor: '#e5e7eb',
                },
                '& .MuiOutlinedInput-notchedOutline': {
                  border: 'none',
                },
                '& .MuiInputBase-input.Mui-disabled': {
                  color: '#000',
                  WebkitTextFillColor: '#000',
                },
              }),
            }}
            InputProps={{
              ...params.InputProps,
              notched: false,
            }}
          />
        )}
        renderOption={(props, option, { inputValue }) => {
          const text = option.industryType;
          const searchTerm = inputValue.trim();
          const regex = new RegExp(`(${searchTerm})`, 'gi');
          const parts = text.split(regex);

          const highlightedText = parts.map((part, i) =>
            part.toLowerCase() === searchTerm.toLowerCase() ? (
              <span key={i} className="bg-yellow-300 font-semibold">
                {part}
              </span>
            ) : (
              <span key={i}>{part}</span>
            )
          );

          const isLong = text.length > 30;

          return (
            <li {...props}>
              {isLong ? (
                <Tooltip
                  title={
                    <Box
                      sx={{
                        maxWidth: 300,
                        maxHeight: 150,
                        overflowY: 'auto',
                        whiteSpace: 'normal',
                        p: 1,
                        bgcolor: 'white',
                        color: 'black',
                        borderRadius: 1,
                        boxShadow: 3,
                      }}
                    >
                      <Typography variant="body2" sx={{ whiteSpace: 'normal' }}>
                        {highlightedText}
                      </Typography>
                    </Box>
                  }
                  placement="right"
                  arrow
                  componentsProps={{
                    tooltip: {
                      sx: {
                        bgcolor: 'transparent',
                        p: 0,
                      },
                    },
                  }}
                >
                  <span
                    style={{
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      display: 'block',
                      maxWidth: '250px',
                    }}
                  >
                    {highlightedText}
                  </span>
                </Tooltip>
              ) : (
                <span
                  style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    display: 'block',
                    maxWidth: '250px',
                  }}
                >
                  {highlightedText}
                </span>
              )}
            </li>
          );
        }}
      />
    </div>
  );
};

export default IndustryAutocomplete
